import EventCalendarMode from "./eventCalendarMode";

export default EventCalendarMode;
